import Component from "@glimmer/component"
import type { ArticleSliceVideo } from "@shared/models/prismic-article"
import type { ExplainerSliceVideoStep } from "@shared/models/prismic-explainer"
import styles from "./wistia-video.module.css"

interface Args {
  slice: ExplainerSliceVideoStep | ArticleSliceVideo
}
export default class WistiaVideoComponent extends Component<Args> {
  readonly styles = styles

  get aspectRatio() {
    return (this.args.slice.primary.height / this.args.slice.primary.width) * 100
  }
}
